import { createSelector } from '@ngrx/store';

import { ParameterResult } from '@models/swagger';
import { State } from './reducer';
import { selectAlarmTypeState } from '../selectors';

export const getData = createSelector(selectAlarmTypeState, (state: State) => state.data);

export const getError = createSelector(selectAlarmTypeState, (state: State) => state.error);

export const getLoading = createSelector(selectAlarmTypeState, (state: State) => state.loading);

export const mapData = <T>(fn: (data: ParameterResult) => T) =>
  createSelector(selectAlarmTypeState, (state: State) => fn(state.data));
